module.exports = __webpack_public_path__ + "static/img/stage-mode-bg.733ab106.png";